<div class="header">
  <strong class="title">{{ 'gearConfig.title' | translate }}</strong>
  <button *ngIf="(config | keyvalue)?.length > 0" mat-icon-button class="xs"
    [matTooltip]="'gearConfig.reset.tooltip' | translate" matTooltipPosition="right"
    (click)="confirmReset()">
    <mat-icon class="xs">replay</mat-icon>
  </button>
</div>
<div *ngIf="(config | keyvalue)?.length === 0">{{ 'gearConfig.noConfig' | translate }}</div>
<form [formGroup]="form">
  <div *ngFor="let parameter of config | keyvalue" test-id="gear-config-parameter" class="gear-config-parameter">
    <div class="gear-config-info">
      <span>{{ parameter.key }}</span>
      <mat-icon *ngIf="parameter.value.description" class="xs" [matTooltip]="parameter.value.description"
        matTooltipPosition="left" matTooltipClass="tooltip-multiline">info</mat-icon>
    </div>
    <div class="gear-config-value">
      <mat-form-field *ngIf="$any(parameter.value).items?.enum" appearance="outline" class="full-width">
        <!-- Enumerated array -->
        <mat-select multiple [formControlName]="parameter.key" test-id="gear-config-field" [placeholder]="getPlaceholder(parameter.key)">
          <mat-option *ngFor="let option of $any(parameter.value).items.enum" [value]="option">{{ option }}</mat-option>
        </mat-select>
        <mat-error>{{ getError(parameter.key) }}</mat-error>
      </mat-form-field>
      <mat-form-field *ngIf="parameter.value?.enum" appearance="outline" class="full-width">
        <!-- Single value enum -->
        <mat-select [formControlName]="parameter.key" test-id="gear-config-field" [placeholder]="getPlaceholder(parameter.key)">
          <mat-option *ngFor="let option of parameter.value.enum" [value]="option">{{ option }}</mat-option>
        </mat-select>
        <mat-error>{{ getError(parameter.key) }}</mat-error>
      </mat-form-field>
      <ng-container *ngIf="!($any(parameter.value).items?.enum || parameter.value?.enum)" [ngSwitch]="parameter.value.type">
        <!-- Unbounded array -->
        <mat-form-field *ngSwitchCase="'array'" class="full-width no-float-space">
          <fw-chip-input [formControlName]="parameter.key" test-id="gear-config-field" [placeholder]="getPlaceholder(parameter.key)" [allowDuplicates]="true"></fw-chip-input>
          <mat-error>{{ getError(parameter.key) }}</mat-error>
        </mat-form-field>
        <!-- Boolean -->
        <mat-checkbox *ngSwitchCase="'boolean'" [formControlName]="parameter.key" test-id="gear-config-field"></mat-checkbox>
        <mat-form-field *ngSwitchDefault appearance="outline" class="full-width" [ngSwitch]="parameter.value.type">
          <!-- Integer -->
          <input *ngSwitchCase="'integer'" type="number" test-id="gear-config-field" matInput step="1"
            [formControlName]="parameter.key" [placeholder]="getPlaceholder(parameter.key)">
          <!-- Number -->
          <input *ngSwitchCase="'number'" type="number" test-id="gear-config-field" matInput step="0.1"
            [formControlName]="parameter.key" [placeholder]="getPlaceholder(parameter.key)">
          <!-- String -->
          <input *ngSwitchDefault type="text" test-id="gear-config-field" matInput
            [formControlName]="parameter.key" [placeholder]="getPlaceholder(parameter.key)">
          <mat-error>{{ getError(parameter.key) }}</mat-error>
        </mat-form-field>
      </ng-container>
    </div>
  </div>
</form>
